// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Belt_Id = require("@rescript/runtime/lib/js/Belt_Id.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let Belt_Map = require("@rescript/runtime/lib/js/Belt_Map.js");
let DateFns = require("date-fns");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Primitive_int = require("@rescript/runtime/lib/js/Primitive_int.js");

function toString(notificationTime) {
  switch (notificationTime) {
    case "Today" :
      return "Today";
    case "Yesterday" :
      return "Yesterday";
    case "Last7Days" :
      return "Last 7 Days";
    case "OlderThanAWeek" :
      return "Older than a week";
  }
}

let cmp = Primitive_int.compare;

let order = [
  "Today",
  "Yesterday",
  "Last7Days",
  "OlderThanAWeek"
];

function groupByDays(tuples) {
  let Cmp = Belt_Id.comparable(cmp);
  let empty = Belt_Map.make(Cmp);
  let secondElement = x => x[1];
  let grouped = Stdlib_Array.reduce(tuples, empty, (map, item) => Belt_Map.update(map, secondElement(item), extra => {
    let v = item[0];
    if (extra !== undefined) {
      return extra.concat([v]);
    } else {
      return [v];
    }
  }));
  return order.map(ordinal => [
    ordinal,
    Belt_Map.get(grouped, ordinal)
  ]);
}

function numberOfDaysToType(x) {
  if (x !== 0) {
    if (x !== 1) {
      if (x <= 7) {
        return "Last7Days";
      } else {
        return "OlderThanAWeek";
      }
    } else {
      return "Yesterday";
    }
  } else {
    return "Today";
  }
}

function groupNotifications(notifications, getDate) {
  let today = new Date();
  return groupByDays(notifications.map(n => [
    n,
    DateFns.differenceInDays(today, UTCDate.toUnzonedDate(getDate(n)))
  ]).map(x => [
    x[0],
    numberOfDaysToType(x[1] | 0)
  ])).map(x => {
    let vs = x[1];
    let k = x[0];
    if (vs !== undefined) {
      return [
        k,
        vs
      ];
    } else {
      return [
        k,
        []
      ];
    }
  }).filter(x => x[1].length !== 0);
}

let NotificationGrouper = {
  toString: toString,
  cmp: cmp,
  order: order,
  groupByDays: groupByDays,
  numberOfDaysToType: numberOfDaysToType,
  groupNotifications: groupNotifications
};

exports.NotificationGrouper = NotificationGrouper;
/* UTCDate Not a pure module */
